<template>
  <div class="credit-loan-case-details" v-loading="_gHlp.isLoading('fetch_case')" element-loading-text="Optimize and checking data...">
		<div v-if="!_gHlp.isEmpty(activeCase)">
			<ModalAddDisbursement ref="modal_add_disbursement" @closeModal="closeModal()"/>
			<ModalAddCollection ref="modal_add_collection" @closeModal="closeModal()"/>
			<ModalAddRedemption ref="modal_add_redemption"/>
		</div>

    <base-header class="pb-6" v-if="!_gHlp.isEmpty(activeCase) && !_gHlp.isLoading('fetch_case')">
      <b-row align-v="center" class="py-2">
        <b-col md="3" lg="3" cols="auto">
          <button @click="goBack" class="btn btn-link text-primary p-0" style="text-decoration: none;">
            <b-icon icon="chevron-left"></b-icon>
            Back To List
          </button>
        </b-col>
        <b-col md="9" lg="9" cols="auto" class="d-flex align-items-center justify-content-between">
					<div class="header-assign-to-buttons">
						<el-popover
							placement="top"
							width="300"
							trigger="click"
							:disabled="is_deleted">
							<b-form-group label="LA Date">
									<el-date-picker
									v-model="form.loan_approved_date"
									value-format="yyyy-MM-dd"
									type="date"
									placeholder="Pick a day"
									@change="updateCaseDate"
									>
									</el-date-picker>
							</b-form-group>
							<b-button-group slot="reference" class="mx-2">
								<b-button size="sm" variant="outline-light">LA Date</b-button>
								<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCase,'loan_approved_date',"-") | dateFormatString }}</b-button>
							</b-button-group>
						</el-popover>
						<el-popover
							placement="top"
							width="300"
							trigger="click"
							:disabled="is_deleted">
							<b-form-group label="LO Date">
									<el-date-picker
									v-model="form.letter_offer_date"
									value-format="yyyy-MM-dd"
									type="date"
									placeholder="Pick a day"
									@change="updateCaseDate"
									>
									</el-date-picker>
							</b-form-group>
							<b-button-group slot="reference" class="mx-2">
								<b-button size="sm" variant="outline-light">LO Date</b-button>
								<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCase,'letter_offer_date',"-") | dateFormatString }}</b-button>
							</b-button-group>
						</el-popover>
					</div>
          <div class="header-assign-to-buttons">
            
						<b-button-group class="mx-2">
							<b-button size="sm" variant="outline-light">Credit Officer</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeLoanEC,'loan_officer_name','-') }}</b-button>
						</b-button-group>
						
						<b-button-group class="mx-2">
							<b-button size="sm" variant="outline-light">SSA Officer</b-button>
							<b-button class="text-dark" size="sm" variant="outline-light" disabled>{{ _gHlp.getValue(activeCustomerInv,'ssa_name','-') }}</b-button>
						</b-button-group>

            <el-dropdown trigger="click" v-if="!is_deleted">
              <el-button type="primary" class="px-3" size="mini">
                <p>Add</p>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="d-flex align-items-center" @click.native="$refs.modal_add_disbursement.show()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="12" viewBox="0 0 576 512">
                    <path fill="#13663E"
                      d="M312 24v10.5c6.4 1.2 12.6 2.7 18.2 4.2 12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5-7.3-.1-14.7 1.7-19.4 4.4-2.1 1.3-3.1 2.4-3.5 3-.3.5-.7 1.2-.7 2.8v.6c.2.2.9 1.2 3.3 2.6 5.8 3.5 14.4 6.2 27.4 10.1l.9.3c11.1 3.3 25.9 7.8 37.9 15.3 13.7 8.6 26.1 22.9 26.4 44.9.3 22.5-11.4 38.9-26.7 48.5-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24v-11.4c-9.5-2.3-18.2-5.3-25.6-7.8-2.1-.7-4.1-1.4-6-2-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6.9 5 1.7 7.3 2.5 13.6 4.6 23.4 7.9 33.9 8.3 8 .3 15.1-1.6 19.2-4.1 1.9-1.2 2.8-2.2 3.2-2.9.4-.6.9-1.8.8-4.1v-.2c0-1 0-2.1-4-4.6-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4-13.5-8.1-26.5-22-26.6-44.1-.1-22.9 12.9-38.6 27.7-47.4 6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm256.2 312.3c13.1 17.8 9.3 42.8-8.5 55.9l-126.6 93.3c-23.4 17.2-51.6 26.5-80.7 26.5H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h36.8l44.9-36c22.7-18.2 50.9-28 80-28H352c17.7 0 32 14.3 32 32s-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h120.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384h-.9.9z" />
                  </svg>
                  Disbursement
                </el-dropdown-item>
                <el-dropdown-item class="d-flex align-items-center" @click.native="$refs.modal_add_collection.show()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="12" viewBox="0 0 576 512">
                    <path fill="#13663E"
                      d="M64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64v-64c35.3 0 64 28.7 64 64zM64 192v-64h64c0 35.3-28.7 64-64 64zm384 192c0-35.3 28.7-64 64-64v64h-64zm64-192c-35.3 0-64-28.7-64-64h64v64zm-224-32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                  </svg>
                  Collection
                </el-dropdown-item>
                <el-dropdown-item class="d-flex align-items-center" @click.native="$refs.modal_add_redemption.show()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="16" height="16" viewBox="0 0 24 24">
                    <g fill="none" stroke="#13663E" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                      <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
                      <path d="M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H10m2 0v1m0-8v1" />
                    </g>
                  </svg>
                  Redemption
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
						<el-button v-if="!is_deleted" type="danger" class="px-3 mx-1" size="mini" @click="!_gHlp.isEmpty(activeCase.psal_id) ? cancelCase() : cancelProceed('cancel','You won\'t be able to revert this!')">
                <p>Cancel</p>
            </el-button>
						<el-tooltip content="Recalculate Case" placement="top">
							<el-button type="warning" class="px-3 mx-1" size="mini" @click="recalculate()">
								<p class="text-white"><i class="fa fa-sync"></i></p>
							</el-button>
						</el-tooltip>
            <!-- <el-dropdown trigger="click" style="cursor: pointer" class="ml-4">
              <p class="el-dropdown-link mb-0 top-line">
                <b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
              </p>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                    <path fill="#13663E"
                      d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
                  </svg>
                  View Activity Log
                </el-dropdown-item>
                <el-dropdown-item>
                  <span class="text-danger">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512 512">
                      <path fill="currentColor"
                        d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64c0 247.4 200.6 448 448 448 18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368c-70.4-33.3-127.4-90.3-160.7-160.7l49.3-40.3c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
                    </svg>
                    View Call Log
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </div>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6" v-if="!_gHlp.isEmpty(activeCase) && !_gHlp.isLoading('fetch_case')">
      <b-row>
        <b-col cols="12" lg="3">
          <CustomerBiodata :class="(is_deleted ? 'archived-section' : '')" />
          <AccountStatus v-if="active_tab === 'overview'"  :lastStatements="last3Statements" :class="(is_deleted ? 'archived-section' : '')"/>
          <Settlement :class="(is_deleted ? 'archived-section' : '')" />
          <Remarks :class="(is_deleted ? 'archived-section' : '')" />
        </b-col>
        <b-col cols="12" lg="9">
					<ApprovalNotif :active_tab="active_tab"/>
          <CasesSummary />
          <el-tabs v-model="active_tab" @tab-click="handleChangeTab">
            <el-tab-pane label="Overview" name="overview">
              <TabOverview />
            </el-tab-pane>
            <el-tab-pane label="Disbursement" name="disbursement">
              <TabDisbursement />
            </el-tab-pane>
            <el-tab-pane label="Collection" name="collection">
              <TabCollection />
            </el-tab-pane>
            <el-tab-pane label="Redemption" name="redemption">
              <TabRedemption />
            </el-tab-pane>
            <el-tab-pane label="Documents" name="documents" :disabled="!enabledDocument">
              <TabDocuments  v-if="enabledDocument"/>
            </el-tab-pane>
          </el-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { Button, Dropdown, DropdownMenu, DropdownItem, Tabs, TabPane, Popover, DatePicker } from 'element-ui'
// import CaseCustomerBiodata from '@/views/CreditLoanCase/CaseDetail/LeftComponents/CaseCustomerBiodata'
import CustomerBiodata from '@/views/CustomerProfile/LeftComponents/CustomerBiodata'
import AccountStatus from '@/views/CreditLoanCase/CaseDetail/LeftComponents/AccountStatus'
import Settlement from '@/views/CreditLoanCase/CaseDetail/LeftComponents/Settlement'
import Remarks from '@/views/CreditLoanCase/CaseDetail/LeftComponents/Remarks'
import ApprovalNotif from '@/views/CreditLoanCase/CaseDetail/CenterComponents/ApprovalNotif'
import CasesSummary from '@/views/CreditLoanCase/CaseDetail/CenterComponents/CasesSummary'
import TabOverview from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Overview/TabOverview'
import TabDisbursement from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Disbursement/TabDisbursement'
import TabCollection from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Collection/TabCollection'
import TabRedemption from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Redemption/TabRedemption'
import TabDocuments from '@/views/CreditLoanCase/CaseDetail/CenterComponents/Documents/TabDocuments'
import ModalAddCollection from '@/views/CreditLoanCase/Modals/ModalAddCollection';
import ModalAddDisbursement from '@/views/CreditLoanCase/Modals/ModalAddDisbursement';
import ModalAddRedemption from '@/views/CreditLoanCase/Modals/ModalAddRedemption'

import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
import { swal } from '@/assets/js/httpImports.js'
import {cloneDeep, isEqual} from 'lodash'
import { mapState, mapActions } from 'pinia';
import { useApprovalStore } from '@/stores/approvalStore';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCustomerStore } from '@/stores/customerStore';

export default {
  components: {
    CustomerBiodata,
    AccountStatus,
    Settlement,
    Remarks,
		ApprovalNotif,
    CasesSummary,
    TabOverview,
    TabDisbursement,
    TabCollection,
		TabRedemption,
		TabDocuments,
		ModalAddCollection,
    ModalAddDisbursement,
    ModalAddRedemption,
    [Button.name]: Button,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
		[Button.name]: Button,
		[DatePicker.name]: DatePicker,
  },
  data() {
    return {
      active_tab: 'overview',
			last3Statements: [],
			form:{
				loan_approved_date: null,
				letter_offer_date: null,
			},
      modals: {
        add_disbursement: false,
        add_collection: false,
      }
    };
  },
	created() {
		this.initPage();
		gEventBus.$on('refresh-cases', this.refreshCase)
	},
	beforeDestroy() {
		gEventBus.$off('refresh-cases', this.refreshCase)
	},
	beforeUnmount(){
		this.clearCaseState();
		this.clearCustomerState();
		this.clearLoanEcState();
	},
	computed: {
		...mapState(useCustomerStore, ['activeCustomer','activeCustomerInv','activeLoanEC']),
    ...mapState(useLoanCaseStore, ['activeCase']),
		is_deleted(){
			return !_gHlp.isEmpty(this.activeCase.deleted_at);
		},
		enabledDocument() {
			return (!_gHlp.isEmpty(this.activeCustomer));
		},
		default_cancel_message(){
			return '<p class="text-left mx-4 px-2">This case have related with other record : <br/>'
			+'Case Ids : ' + _gHlp.getValue(this.activeCase,'related_case_ids','-') + '<br/>'
			+'Loan Eligible Calculator Id : '+_gHlp.getValue(this.activeCase,'loan_ec_id','-')+'<br/>'
			+'Initial Proposal Id : '+_gHlp.getValue(this.activeCase,'psal_id','-') + '<br/>'
			+'<span class="text-danger">All related will canceled.</span><p>';
		}
  },
  watch: {
    '$route.query.active': {
      handler(newValue, oldValue) {
        this.active_tab = newValue
      },
      immediate: true
    },
		'activeCase': {
			handler(newValue, oldValue) {
				if(!_gHlp.isEmpty(newValue)){
					this.form.loan_approved_date = cloneDeep(newValue.loan_approved_date)
					this.form.letter_offer_date = cloneDeep(newValue.letter_offer_date)
				}
			},
			immediate: true
		},
  },
  methods: {
		...mapActions(useApprovalStore, ['getAprovalList']),
		...mapActions(useLoanCaseStore, ['getCase','getStatementList','getRepayList','getRemarkList','updateCase','clearCaseState','checkStatementList']),
		...mapActions(useCustomerStore, ['getCustomer','getLoanEC','clearCustomerState','clearCustomerState']),
		goBack(){
			this.$router.back()
		},
    handleChangeTab(obj, e) {
      const query = { ...this.$route.query, active: obj.name }
      this.$router.push({ path: this.$route.path, query })
    },
		refreshCase(){
			_gHlp.setLoading('fetch_case')
			this.getCase(this.activeCase.case_id).then(resp => {
				this.fetchAll();
				_gHlp.removeLoading('fetch_case')
			}).catch(err => {
				_gHlp.removeLoading('fetch_case')
			});
		},
		async initPage(){
			_gHlp.setLoading('fetch_case')
			// _gHlp.setLoading('fetch_loan_ec')
			// _gHlp.setLoading('fetch_credit_report')
			if (_gHlp.isEmpty(this.activeCase)) {
				let case_id = this.$route.params.case_id;
				if(_gHlp.isEmpty(case_id)){
					this.$router.push('/customers-list/all-customer')
				}else{
					await this.checkStatementList(this.$route.params.case_id)
					this.getCase(case_id).then(resp => {
						this.fetchAll();
						_gHlp.removeLoading('fetch_case')
					}).catch(err => {
						_gHlp.removeLoading('fetch_case')
					});
				}
			} else {
				this.fetchAll();
				_gHlp.removeLoading('fetch_case')
			}
		},
		fetchAll(){
			this.getCustomer(this.activeCase.customer_id)
			this.getLoanEC(this.activeCase.loan_ec_id,this.activeCase.customer_id)
			//FETCH DISBURSEMENT
			//FETCH COLLECTIONS
			//FETCH REPAYMENT
			this.getRepayList();
			//FETCH REDEMPTION
			//FETCH REMARKS
			_gHlp.setLoading('fetch_case_remark')

			this.getRemarkList({paginate:'no_paginate'}).then(resp=>{
				_gHlp.removeLoading('fetch_case_remark')
			}).catch(err=>{
				_gHlp.removeLoading('fetch_case_remark')
			});
			//FETCH STATEMENTS

			this.getStatementList({
				paginate: 3,
				page: 1,
				orderBy: {
					statement_id:'desc'
				}
			}).then(resp => {
				this.last3Statements = resp.data
			});

			//FETCH APPROVAL
			this.getAprovalList({
				search:{
					custom_key: 'CASE_' + this.activeCase.case_id,
					approve_status: 'Pending'
				},
				paginate:'no_paginate'
			});
		},
		closeModal() {
      this.modals.add_disbursement = false;
      this.modals.add_collection = false;
    },
		updateCaseDate() {
			let params = {};
			
			if(!_gHlp.isEmpty(this.form.loan_approved_date) && (this.form.loan_approved_date != this.activeCase.loan_approved_date)){
				params['loan_approved_date'] = _gHlp.formatDate(this.form.loan_approved_date,'Y-m-d') 
			}
			if(!_gHlp.isEmpty(this.form.letter_offer_date) && (this.form.letter_offer_date != this.activeCase.letter_offer_date)){
				params['letter_offer_date'] = _gHlp.formatDate(this.form.letter_offer_date,'Y-m-d') 
			}

			if(_gHlp.isEmpty(params)) return false;
			
			swal.fire({
				title: 'Date Change',
				text: "Confirm change la / lo date",
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.updateCase(params).then(res => {
						_gNotif.notifySuccess("Case la / lo date has been update")
						this.refreshCase()
					});
				}
			})
		},
		cancelCase(){
			swal.fire({
				title: "Are you sure?",
				html: this.default_cancel_message + " What you want to do for proposal after archive the case ?",
				icon: 'info',
				showDenyButton: true,
				showCancelButton: true,
				confirmButtonText: "Cancel Proposal",
				denyButtonText: "Reject Proposal",
				cancelButtonText: "Abort",
				confirmButtonColor: "#F56C6C",
				denyButtonColor: "#FEC823",
				cancelButtonColor: "#13663E",
			}).then((result) => {
				/* Read more about isConfirmed, isDenied below */
				if (result.isConfirmed) {
					this.cancelProceed('canceled','This action will cancel related proposal on SAS system, and cannot to appeal')	
				} else if (result.isDenied) {
					this.cancelProceed('rejected_by_credit_mgr','This action will reject related proposal on SAS system, and SSA Manager able resubmit for appeal')	
				}
			});
		},
		cancelProceed(action,message){
			let full_msg = (_gHlp.isEmpty(this.activeCase.psal_id)) ? this.default_cancel_message + message : message;

			swal.fire({
        title: 'Confirmation',
        html: full_msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!'
      }).then((result) => {
        if (result.isConfirmed) {

					const params = {
						close_case: action
					}
					this.updateCase(params,this.activeCase.case_id).then((resp) => {
						_gNotif.notifySuccess("Case has been archived")
						this.$router.push('/credit-loan-case/all-case')
					}).catch((e) => {
						_gNotif.notifyError('Failed arcive case');
					})

        }
      })
		},
		recalculate(){
			const html = 'This action will do process : <ul>'
				+'<li>Repair Case Summary & Collection Status</li>'
				+'<li>Recalculate Disbursement</li>'
				+'<li>Recalculate Collection</li>'
				+'<li>Regenerate Statement Listing</li>'
				+'<li>And Recheck Late Charge Payment If exist</li>';
				+'</ul>';

			swal.fire({
				title: 'Recalculate Confirmation',
				html: html,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					this.updateCase({recalculate: 'repair_repayment'},this.activeCase.case_id).then((resp) => {
						_gNotif.notifySuccess("Case has updated")
						this.refreshCase()
					}).catch((e) => {
						_gNotif.notifyError('Failed regenerate repayment');
					})
				}
			});
		}
  }
}
</script>